import { config } from "@/config";
import { type Libraries } from "@react-google-maps/api";

export const GOOGLE_MAPS_LIBRARIES: Libraries = ["places", "geocoding"];

export const GOOGLE_MAPS_SCRIPT_OPTIONS = {
  id: "google-maps-script",
  googleMapsApiKey: config.maps.apiKey,
  libraries: GOOGLE_MAPS_LIBRARIES
} as const;

export { MapLocationSelector } from "./map-location-selector";
export { MapLocationDialog } from "./map-location-dialog";
export type { MapLocation } from "./map-location-selector";
export type { MapLocationDialogProps } from "./map-location-dialog";
